
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
import axios from 'axios';
import { api_url } from '../../utils/utils'
import { paginationTotal } from '../../utils/pagination'
export const get_admin_orders = createAsyncThunk(
    'order/get_admin_orders',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }

        try {
            const params = new URLSearchParams({ page, searchValue: searchValue || '', parPage })
            const { data } = await axios.get(`${api_url}/api/admin/orders?${params.toString()}`, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_seller_orders = createAsyncThunk(
    'order/get_seller_orders',
    async ({ parPage, page, searchValue, sellerId }, { rejectWithValue, fulfillWithValue, getState }) => {
            // const token = getState().auth.token
            // const config = {
            //     headers: {
            //         'Authorization': `Bearer ${token}`
            //     }
            // }
        try {
            const params = new URLSearchParams({ page, searchValue: searchValue || '', parPage })
            const { data } = await axios.get(`${api_url}/api/seller/orders/${sellerId}?${params.toString()}`, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_admin_order = createAsyncThunk(
    'order/get_admin_order',
    async (orderId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await axios.get(`${api_url}/api/admin/order/${orderId}`, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_seller_order = createAsyncThunk(
    'order/get_seller_order',
    async (orderId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await axios.get(`${api_url}/api/seller/order/${orderId}`, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// ✅ YENİ - Customer Orders
export const get_customer_orders = createAsyncThunk(
    'order/get_customer_orders',
    async ({ customerId, status }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await axios.get(`${api_url}/api/home/customer/get-orders/${customerId}/${status}`, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// ✅ YENİ - Get Single Customer Order
export const get_order = createAsyncThunk(
    'order/get_order',
    async (orderId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await axios.get(`${api_url}/api/home/customer/get-order/${orderId}`, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const admin_order_status_update = createAsyncThunk(
    'order/admin_order_status_update',
    async ({ orderId, info }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }

        try {
            const { data } = await api.put(`/admin/order-status/update/${orderId}`, info, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const seller_order_status_update = createAsyncThunk(
    'order/seller_order_status_update',
    async ({ orderId, info }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await api.put(`/seller/order-status/update/${orderId}`, info, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const OrderReducer = createSlice({
    name: 'order',
    initialState: {
        successMessage: '',
        errorMessage: '',
        totalOrder: 0,
        order: {},
        myOrders: [],
        customerOrders: [] // ✅ YENİ
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        },
        mergeRealtimeSellerOrder: (state, { payload }) => {
            const authOrderId = payload.authOrderId || payload.orderId
            const customerOrderId = payload.customerOrderId
            const nextSellerCredited = payload.sellerBalanceCredited ?? payload.order?.sellerBalanceCredited
            const nextEscrowStatus = payload.escrowStatus ||
                payload.order?.escrowStatus ||
                (nextSellerCredited ? 'released' : undefined)
            const nextPaymentStatus = payload.payment_status ||
                payload.paymentStatus ||
                (nextEscrowStatus === 'held' || nextEscrowStatus === 'released' || nextSellerCredited ? 'Ödənilib' : undefined)
            const index = state.myOrders.findIndex(order =>
                order._id === authOrderId ||
                order.authOrderId === authOrderId ||
                order.orderId === customerOrderId
            )

            const patch = {
                ...(payload.order || {}),
                _id: authOrderId,
                orderId: customerOrderId || payload.orderId,
                sellerId: payload.sellerId,
                customerId: payload.customerId,
                payment_status: nextPaymentStatus,
                paymentDisplayStatus: nextPaymentStatus === 'Ödənilib' ? 'Ödənilib' : undefined,
                escrowStatus: nextEscrowStatus,
                escrowDisplayStatus: nextEscrowStatus === 'held' ? 'Escrowda saxlanılır' : nextEscrowStatus === 'released' ? 'Buraxıldı' : undefined,
                delivery_status: payload.sellerDeliveryStatus || payload.delivery_status,
                deliveryStatus: payload.deliveryStatus,
                isConfirmed: payload.isConfirmed,
                confirmedAt: payload.confirmedAt,
                sellerBalanceCredited: nextSellerCredited,
                sellerCreditDisplayStatus: nextSellerCredited ? 'Köçürülüb' : undefined,
                updatedAt: payload.updatedAt || new Date().toISOString()
            }

            if (index >= 0) {
                state.myOrders[index] = {
                    ...state.myOrders[index],
                    ...patch,
                    _id: state.myOrders[index]._id
                }
            }

            if (state.order?._id === authOrderId || state.order?.orderId === customerOrderId) {
                state.order = {
                    ...state.order,
                    ...patch,
                    _id: state.order._id
                }
            }
        },
        prependRealtimeSellerOrder: (state, { payload }) => {
            const authOrderId = payload.authOrderId || payload.orderId
            const exists = state.myOrders.some(order => order._id === authOrderId)
            const paymentStatus = payload.payment_status ||
                payload.paymentStatus ||
                (payload.escrowStatus === 'held' ? 'Ödənilib' : 'Ödəniş olunmayıb')

            if (!exists) {
                state.myOrders.unshift({
                    _id: authOrderId,
                    orderId: payload.customerOrderId || payload.orderId,
                    sellerId: payload.sellerId,
                    customerId: payload.customerId,
                    products: payload.productName
                        ? [{ name: payload.productName, quantity: payload.quantity }]
                        : [],
                    price: payload.totalPrice || payload.price || 0,
                    payment_status: paymentStatus,
                    paymentDisplayStatus: paymentStatus === 'Ödənilib' ? 'Ödənilib' : undefined,
                    escrowStatus: payload.escrowStatus || null,
                    escrowDisplayStatus: payload.escrowStatus === 'held' ? 'Escrowda saxlanılır' : undefined,
                    sellerBalanceCredited: payload.sellerBalanceCredited ?? false,
                    sellerCreditDisplayStatus: payload.sellerBalanceCredited ? 'Köçürülüb' : 'Gözləyir',
                    delivery_status: 'Gözləmədə',
                    deliveryStatus: 'pending',
                    date: payload.createdAt
                        ? new Date(payload.createdAt).toLocaleString('az-AZ')
                        : new Date().toLocaleString('az-AZ'),
                    createdAt: payload.createdAt || new Date().toISOString(),
                    isRealtimePlaceholder: true
                })
                state.totalOrder += 1
            }
        }
    },
    extraReducers: (builder) => {
        builder
            // ADMIN ORDERS
            .addCase(get_admin_orders.fulfilled, (state, { payload }) => {
                state.myOrders = payload.orders || payload.data || []
                state.totalOrder = paginationTotal(payload, 'totalOrder')
            })
            .addCase(get_admin_order.fulfilled, (state, { payload }) => {
                state.order = payload.order
            })

            // ADMIN STATUS UPDATE
            .addCase(admin_order_status_update.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
            })
            .addCase(admin_order_status_update.rejected, (state, { payload }) => {
                state.errorMessage = payload.message
            })

            // SELLER ORDERS
            .addCase(get_seller_orders.fulfilled, (state, { payload }) => {
                state.myOrders = payload.orders || payload.data || []
                state.totalOrder = paginationTotal(payload, 'totalOrder')
            })
            .addCase(get_seller_order.fulfilled, (state, { payload }) => {
                state.order = payload.order
            })

            // SELLER STATUS UPDATE
            .addCase(seller_order_status_update.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
            })
            .addCase(seller_order_status_update.rejected, (state, { payload }) => {
                state.errorMessage = payload.message
            })

            // ✅ YENİ - CUSTOMER ORDERS
            .addCase(get_customer_orders.fulfilled, (state, { payload }) => {
                state.customerOrders = payload.orders
            })
            .addCase(get_order.fulfilled, (state, { payload }) => {
                state.order = payload.order
            })
    }
})

export const {
    messageClear,
    mergeRealtimeSellerOrder,
    prependRealtimeSellerOrder
} = OrderReducer.actions
export default OrderReducer.reducer











